/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { Formik, FormikHelpers } from "formik";

import { useHistory } from "react-router-dom";
import { LuCalendarRange, LuClock, LuScale, LuUsers } from "react-icons/lu";

import moment from "moment";

import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { ListBox } from "primereact/listbox";
import { SelectButton } from "primereact/selectbutton";

import api from "../../../../services/api";

import { useToast } from "../../../../hooks/toast";
import useResponsaveis from "../../../../hooks/useResponsaveis";

import {
  DateFilter,
  DateFilterValue,
  Field,
  FilterActions,
  FilterStyles,
  Section,
} from "../../../../components/FilterKit";

import { Container } from "./styles";

interface SearchData {
  proc_cod_cliente: number;
  sector: string | string[];
  inCharge: string;
  referenceId: number;
  description: string;
  billedHour: string;
  proc_tipo: string;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
  proc_reg: string;
  proc_num_pasta: string;
  proc_autor: string;
  proc_reu: string;
  doc: string;
}

const SearchHourGeneral: React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD hh:mm:ss");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD hh:mm:ss");

  const [lawsuitRegistrationNumber, setLawsuitRegistrationNumber] =
    useState("");
  const [lawsuitFolderNumber, setLawsuitFolderNumber] = useState("");
  const [author, setAuthor] = useState("");
  const [defendant, setDefendant] = useState("");
  const [customerId, setCustomerId] = useState("0");
  const [referenceId, setReferenceId] = useState(0);
  const [billedHour, setBilledHour] = useState("N");
  const [hourType, setHourType] = useState("todos");
  const [description, setDescription] = useState("");

  const [initialRegistrationDate, setInitialRegistrationDate] = useState<
    string | Date | Date[] | null
  >(new Date(startOfMonth));
  const [finalRegistrationDate, setFinalRegistrationDate] = useState<
    string | Date | Date[] | null
  >(new Date(endOfMonth));

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [sectorOptions, setSectorOptions] = useState([{}]);
  const [referenceOptions, setReferenceOptions] = useState([{}]);
  const [sectorValue, setSectorValue] = useState(["all"]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [inCharge, setInCharge] = useState<any>("global|0");
  const [dateFilterType, setDateFilterType] = useState("data");

  const validationSchema = null;

  const billedHourOptions = [
    { name: "Sim", value: "S", style: "font-size: small;" },
    { name: "Não", value: "N", style: "font-size: small;" },
    { name: "Ambos", value: "A", style: "font-size: small;" },
  ];

  const hourTypeOptions = [
    { name: "Processo", value: "processo", style: "font-size: small;" },
    { name: "Assessoria", value: "assessoria", style: "font-size: small;" },
    { name: "Todos", value: "todos", style: "font-size: small;" },
  ];

  useEffect(() => {
    (async () => {
      await api.get("/lawsuits/references/show/all").then((response) => {
        referenceOptions.push({
          name: "Padrão",
          value: 0,
        });
        response.data.map(
          (reference: {
            horas_referencia_id: number;
            horas_referencia_nome: string;
          }) =>
            referenceOptions.push({
              name: reference.horas_referencia_nome,
              value: reference.horas_referencia_id,
            })
        );
      });
      referenceOptions.splice(0, 1);
      setReferenceOptions((oldOptions) => [...oldOptions, referenceOptions]);
    })();
  }, [referenceOptions]);

  useEffect(() => {
    (async () => {
      await api.get("customers/show/all").then((response) => {
        response.data.map(
          (customer: { cliente_id: number; cliente_nome: string }) =>
            customersOptions.push({
              name: customer.cliente_nome,
              value: customer.cliente_id,
            })
        );
      });
      customersOptions.splice(0, 1);

      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  useEffect(() => {
    (async () => {
      await api
        .get("/management/attorneys/show/inchargelawsuits/attorneys")
        .then((response) => {
          if (response.data.length > 0) {
            sectorOptions.push({
              name: "Todos",
              value: "all",
            });
            response.data.map((sector: { setor_adv: string }) =>
              sectorOptions.push({
                name: sector.setor_adv,
                value: sector.setor_adv,
              })
            );
          }
        });

      await api
        .get("/management/attorneys/show/inchargelawsuits/others")
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((sector: { setor_adm: string }) => {
              if (sectorOptions.indexOf(sector.setor_adm) === -1) {
                sectorOptions.push({
                  name: sector.setor_adm,
                  value: sector.setor_adm,
                });
              }
            });
          }
        });

      sectorOptions.splice(0, 1);
      setSectorOptions(sectorOptions);
    })();
  }, [sectorOptions]);

    const { inChargeOptions, filterAttorneysInCharge } = useResponsaveis({
    urlAdvogados: `management/attorneys/show/all/active/lawsuit/${sessionStorage.getItem( "setor" )}/${sessionStorage.getItem("categoria")}`,
    urlAssistentes: `management/assistants/show/all/active/lawsuit/${sessionStorage.getItem( "setor" )}/${sessionStorage.getItem("categoria")}`,
    todos: {
      label: "Todos",
      items: [
        { label: "Todos", value: "global|0" },
        { label: "Todos - exceto estagiários", value: "global|99997" },
        { label: "Todos - exceto assistentes", value: "global|99998" },
        {
          label: "Todos - exceto estagiários e assistentes",
          value: "global|99999",
        },
      ],
    },
  });

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>
  ) => {
    try {
      // const access = JSON.parse(sessionStorage.getItem('@Jurisnet:access') || '{}');
      const access = JSON.parse(
        localStorage.getItem("@Jurisnet:access") || "{}"
      );

      let menu = "";
      let categoria = 0;
      let setorTxt = "";
      if (access) {
        menu = access.menu;
        categoria = Number(access.categoria);
        setorTxt = access.setor;
      }
      const searchFormData = {
        proc_cod_cliente: customerId,
        sector: sectorValue,
        inCharge,
        referenceId,
        description,
        billedHour,
        proc_tipo: hourType,
        dateFilterType,
        proc_data_ajuiz_inicio: initialRegistrationDate,
        proc_data_ajuiz_final: finalRegistrationDate,
        proc_reg: lawsuitRegistrationNumber,
        proc_num_pasta: lawsuitFolderNumber,
        proc_autor: author,
        proc_reu: defendant,
        menu,
        categoria,
        setorTxt,
        doc: "",
      };

      localStorage.removeItem("@Jurisnet:selectedhour");

      history.push({
        pathname: "/report/hour/general",
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: "error",
        title: "Ocorreu um problema",
        description: "Tente repetir a pesquisa ou contate o administrador.",
      });
    }
  };

  const initialValues: SearchData = {
    proc_cod_cliente: 0,
    sector: ["all"],
    inCharge: "global|0",
    referenceId: 0,
    description: "",
    billedHour: "N",
    proc_tipo: "todos",
    proc_data_ajuiz_inicio: new Date(startOfMonth),
    proc_data_ajuiz_final: new Date(endOfMonth),
    proc_reg: "",
    proc_num_pasta: "",
    proc_autor: "",
    proc_reu: "",
    doc: "",
  };

  const toDate = (value: string | Date | Date[] | null) =>
    value instanceof Date ? value : null;

  const dateFilterValue: DateFilterValue = {
    mode: dateFilterType === "periodo" ? "periodo" : "data",
    start: toDate(initialRegistrationDate),
    end: toDate(finalRegistrationDate),
  };

  const sameDay = (value: Date | null, reference: string) =>
    value !== null && value.getTime() === new Date(reference).getTime();

  const activeFilters = [
    customerId !== "0",
    sectorValue.length !== 1 || sectorValue[0] !== "all",
    inCharge !== "global|0",
    referenceId !== 0,
    description.trim() !== "",
    billedHour !== "N",
    hourType !== "todos",
    dateFilterType === "periodo"
      ? dateFilterValue.start !== null || dateFilterValue.end !== null
      : !sameDay(dateFilterValue.start, startOfMonth) ||
        !sameDay(dateFilterValue.end, endOfMonth),
    lawsuitRegistrationNumber.trim() !== "",
    lawsuitFolderNumber.trim() !== "",
    author.trim() !== "",
    defendant.trim() !== "",
  ].filter(Boolean).length;

  return (
    <Container>
      <FilterStyles>
        <Formik
          onSubmit={handleOnSubmit}
          validationSchema={validationSchema}
          enableReinitialize
          initialValues={initialValues}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
          }) => (
            <form className="card search-card" onSubmit={handleSubmit}>
              <header className="search-title">
                <h3>Relatório de Horas - Modelo IV</h3>
                <span className="search-hint">
                  Preencha só o que precisar. Enter pesquisa.
                </span>
              </header>

              <div className="search-grid">
                <div className="search-col">
                  <Section icon={<LuUsers />} title="Cliente e responsável">
                    <div className="row r2">
                      <Field id="proc_cliente" label="Cliente">
                        <Dropdown
                          id="proc_cliente"
                          name="proc_cliente"
                          options={customersOptions}
                          onChange={(e) => setCustomerId(e.target.value)}
                          value={customerId}
                          optionLabel="name"
                          optionValue="value"
                          autoFocus
                          filter
                          resetFilterOnHide
                          filterBy="name"
                          placeholder="Selecione uma opção"
                          emptyFilterMessage="Nenhum registro encontrado"
                        />
                      </Field>
                      <Field id="inChargeDropDown" label="Responsável">
                        <Dropdown
                          id="inChargeDropDown"
                          name="inChargeDropDown"
                          value={inCharge}
                          options={inChargeOptions}
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          onChange={(e: { value: any }) => setInCharge(e.value)}
                          optionLabel="label"
                          optionGroupLabel="label"
                          optionGroupChildren="items"
                        />
                      </Field>
                    </div>
                    <Field id="sector" label="Setor">
                      <ListBox
                        id="sector"
                        name="sector"
                        options={sectorOptions}
                        onChange={(e) => {
                          setSectorValue(e.target.value);
                          filterAttorneysInCharge(e.target.value);
                        }}
                        value={sectorValue}
                        optionLabel="name"
                        optionValue="value"
                        multiple
                        filter
                        filterBy="name"
                        listStyle={{ maxHeight: "130px" }}
                      />
                    </Field>
                  </Section>

                  <Section icon={<LuCalendarRange />} title="Período">
                    <DateFilter
                      id="registro"
                      label="Data de registro"
                      withMode
                      value={dateFilterValue}
                      onChange={(next) => {
                        if (next.mode !== dateFilterType) {
                          setDateFilterType(next.mode);
                        }
                        setInitialRegistrationDate(next.start);
                        setFinalRegistrationDate(next.end);
                      }}
                    />
                  </Section>
                </div>

                <div className="search-col">
                  <Section icon={<LuScale />} title="Processo">
                    <div className="row r2">
                      <Field id="proc_reg" label="Nº do processo">
                        <InputText
                          id="proc_reg"
                          name="proc_reg"
                          onChange={(e) => {
                            setLawsuitRegistrationNumber(e.target.value);
                            handleChange(e);
                          }}
                          value={lawsuitRegistrationNumber}
                        />
                      </Field>
                      <Field id="proc_num_pasta" label="Pasta nº">
                        <InputText
                          id="proc_num_pasta"
                          name="proc_num_pasta"
                          onChange={(e) =>
                            setLawsuitFolderNumber(e.target.value)
                          }
                          onBlur={handleBlur}
                          value={lawsuitFolderNumber}
                        />
                      </Field>
                      <Field id="proc_autor" label="Autor">
                        <InputText
                          id="proc_autor"
                          name="proc_autor"
                          value={author}
                          onChange={(e) => setAuthor(e.target.value)}
                        />
                      </Field>
                      <Field id="proc_reu" label="Réu">
                        <InputText
                          id="proc_reu"
                          name="proc_reu"
                          value={defendant}
                          onChange={(e) => setDefendant(e.target.value)}
                        />
                      </Field>
                    </div>
                  </Section>

                  <Section icon={<LuClock />} title="Filtros do relatório">
                    <div className="row r2">
                      <Field id="proc_cod_adv_resp" label="Referência">
                        <Dropdown
                          id="proc_cod_adv_resp"
                          name="proc_cod_adv_resp"
                          options={referenceOptions}
                          onChange={(e) => setReferenceId(e.target.value)}
                          value={referenceId}
                          optionLabel="name"
                          optionValue="value"
                          filter
                          resetFilterOnHide
                          filterBy="name"
                          placeholder="Selecione uma opção"
                          emptyFilterMessage="Nenhum registro encontrado"
                        />
                      </Field>
                      <Field id="proc_tipo" label="Tipo">
                        <SelectButton
                          id="proc_tipo"
                          value={hourType}
                          options={hourTypeOptions}
                          optionLabel="name"
                          onChange={(e) => setHourType(e.value)}
                        />
                      </Field>
                    </div>
                    <Field id="billed_hours" label="Incluir horas faturadas">
                      <SelectButton
                        id="billed_hours"
                        value={billedHour}
                        options={billedHourOptions}
                        optionLabel="name"
                        onChange={(e) => setBilledHour(e.value)}
                      />
                    </Field>
                    <Field id="description" label="Descrição">
                      <InputTextarea
                        id="description"
                        name="description"
                        value={description || ""}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={3}
                        cols={30}
                      />
                    </Field>
                  </Section>
                </div>
              </div>

              <FilterActions
                active={activeFilters}
                submitLabel="Pesquisar processos"
                onClear={() => handleReset()}
              />
            </form>
          )}
        </Formik>
      </FilterStyles>
    </Container>
  );
};

export default SearchHourGeneral;
